const reviewObservationFieldTransformHelper = response => {
  return response.map(e => {
    return { key: e.key, label: e.name, value: e.name, id: e.id }
  })
}

export default reviewObservationFieldTransformHelper
